import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  boxLoading: {
    backgroundColor: '#fff',
    boxShadow: '0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A',
    marginTop: 25,
    padding: 24,
    paddingBottom: 10,
  },
});
